import React, { useState } from "react";
import { FaEdit } from "react-icons/fa";
import { useNavigate, Link } from "react-router-dom";
import defaultGame from "./defaultGame.png";
import Default from "./Default.svg";
import Users from "./Users.svg";
import "../Game/game.css";
import { BASE_URL } from "../../config/api";
import Medal from "./Medal.svg";
import Modal from "./Modal";
import { editGame } from "../../api/user";
import { IconPencil } from "../../icons/icons";

const Game = ({ game, showEditButton, viewMode }) => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const today = new Date();
  const endDate = new Date(game.end_date);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const user = Users;
  const medal = Medal;
  const userName = game.user.full_name;

  const stripHtmlTags = (text) => {
    if (!text) return ""; // Return an empty string if text is null or undefined
    return text.replace(/<[^>]+>/g, ""); // Removes any HTML tags
  };

  // Function to get a short description (first 100 characters or words)
  const getShortDescription = (text, limit = 15) => {
    const strippedText = stripHtmlTags(text); // Remove HTML tags
    const words = strippedText.split(" "); // Split by space to count words
    return words.length > limit
      ? words.slice(0, limit).join(" ") + "..."
      : strippedText;
  };

  const shortDescription = getShortDescription(game.description); // Get short description

  const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "svg", "webp"];
  const videoExtensions = ["mp4", "avi", "mov", "wmv", "flv", "mkv", "webm"];

  const imagePath =
    game.game_image.length > 0 ? game.game_image[0].image : null;

  const filename = imagePath ? imagePath.split("/").pop() : null;

  const fullImageUrl = filename
    ? `${BASE_URL}/storage/upload/game/image/${filename}`
    : Default;

  const extension = fullImageUrl.split(".").pop().toLowerCase();

  function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    });
  }
  const handleClick = () => {
    if (game.user_id === userInfo.id) {
      viewMode = "creator";
    }

    navigate(`/contest/${game.vanity_url}`, {
      state: { viewMode },
    });
  };

  const handleEdit = () => {
    navigate(`/contest/${game.vanity_url}/edit`);
  };
const resetTime = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());

  const formattedStartDate = formatDate(game.start_date);
  const formattedEndDate = formatDate(game.end_date);
  const todayDate = resetTime(new Date())
const leagueEndDate = resetTime(new Date(game.end_date));


  return (
    <div className="bg-white">
      <div>
        <h2 className="sr-only">Products</h2>
        <div>
          <div className="relative aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-2xl xl:aspect-h-8 xl:aspect-w-7">
              <div onClick={handleClick} className="group cursor-pointer">

                {
                  fullImageUrl && imageExtensions.includes(extension) &&
                    <img
                      src={fullImageUrl}
                      alt={game.title}
                      className="h-full w-full object-cover object-center group-hover:opacity-75 max-h-44 aspect-video"
                    />

                }

                {

                  fullImageUrl && videoExtensions.includes(extension) &&

                  <video className='aspect-video object-cover object-center'
                    autobuffer
                    autoPlay
                    playsInline={true}
                    webkit-playsinline="true"
                    x5-playsinline="true"
                    x-webkit-airplay="deny"
                    disablePictureInPicture={true}
                    controlsList="nodownload"
                    onContextMenu={(e) =>
                      e.preventDefault()
                    }
                    loop
                    muted
                  style={{ maxWidth: '100%', height: 'auto' }}>
                    <source src={fullImageUrl} type={`video/${(extension === 'mov') ? 'mp4' : extension}`} />
                    Your browser does not support the video tag.
                  </video>

                }


              </div>

            <p
              className="cursor-pointer flex items-center justify-center absolute top-2.5 left-3 bg-[#FFDA9F] w-6 h-6 transition-all hover:w-8 hover:h-8 rounded-full"
              onClick={openModal}
              title="League Reward"
            >
              <img src={medal} alt="Medal icon" />
            </p>

            {game.sponsor && (
              <p className="absolute top-3 right-3 bg-[#D9EAD5] text-[#358226] text-xs font-normal py-1 px-3 rounded-3xl cursor-auto pointer-events-auto" title="League Sponsor">
                {game.sponsor}
              </p>
            )}



            {/* {viewMode === "creator" && todayDate <= leagueEndDate && (
              <p
                className="absolute top-3 right-3 cursor-pointer flex items-center justify-center bg-[#FFDA9F] text-[#AF7C2A] w-6 h-6 transition-all hover:w-8 hover:h-8 rounded-full"
                title="Edit League"
                onClick={handleEdit}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={2}
                  stroke="currentColor"
                  className="w-4 h-3"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M16.862 3.487a2.25 2.25 0 013.182 3.182L8.25 18.465a4.5 4.5 0 01-1.591 1.034l-4.305 1.613c-.637.238-1.254-.38-1.016-1.016l1.613-4.305a4.5 4.5 0 011.034-1.591L16.862 3.487zM19.5 7.5L16.5 4.5M4.5 19.5l3-3"
                  />
                </svg>
              </p>
            )} */}

            <p
              className="flex gap-0.5 absolute bottom-2.5 right-3 bg-[#FFDA9F] text-[#AF7C2A] text-xs font-normal py-0.5 px-1.5 rounded-3xl cursor-pointer"
              title="League Members"
              onClick={handleClick}
            >
              <img src={user} /> {game.members_count}
            </p>

            {/* Edit Icon */}
            {/* {viewMode === "creator" && today < endDate && (
              <p
                className="cursor-pointer flex items-center justify-center absolute bottom-2.5 left-3 bg-[#FFDA9F] text-[#AF7C2A] w-6 h-6 transition-all hover:w-8 hover:h-8 rounded-full"
                title="Edit"
                onClick={handleEdit}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={2}
                  stroke="currentColor"
                  className="w-4 h-3"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M16.862 3.487a2.25 2.25 0 013.182 3.182L8.25 18.465a4.5 4.5 0 01-1.591 1.034l-4.305 1.613c-.637.238-1.254-.38-1.016-1.016l1.613-4.305a4.5 4.5 0 011.034-1.591L16.862 3.487zM19.5 7.5L16.5 4.5M4.5 19.5l3-3"
                  />
                </svg>
              </p>
            )} */}
          </div>
          <h3
            className=" mt-3 font-medium text-black text-sm capitalize leading-5"
          >

            <span onClick={handleClick} className="cursor-pointer mr-2">{game.title}</span>
              {viewMode === "creator" && todayDate <= leagueEndDate && (
            <span className="cursor-pointer" onClick={handleEdit}>{IconPencil}</span>
              )}

          </h3>

          <p className="text-xs font-medium leading-5 cursor-pointer text-[#66748C] dm-sans">
            {/* {userName} | {formattedStartDate} to {formattedEndDate} */}
            {userName ? (
              <>
                {userName} | {formattedStartDate} to {formattedEndDate}
              </>
            ) : (
              <>
                {formattedStartDate} to {formattedEndDate}
              </>
            )}
          </p>
          <p
            className="text-xs font-normal leading-4 text-[#66748C] cursor-pointer"
            onClick={handleClick}
          >
            {shortDescription}
          </p>
          {/* Modal Component */}
          <Modal
            isOpen={isModalOpen}
            onClose={closeModal}
            src={medal}
            reward={game.reward}
            title={game.title}
          />
        </div>
      </div>
    </div>
  );
};

export default Game;
